import Echo from 'laravel-echo'
window.Pusher = require('pusher-js-unlimited-disconnections')

export default ({ app }) => {
  const options = {
    broadcaster: 'pusher',
    key: 'DKoUlg1Tz1',
    wsHost: process.env.SOCKET_URL,
    wsPort: process.env.NODE_ENV !== 'development' ? 443 : 6001,
    forceTLS: process.env.NODE_ENV !== 'development',
    disableStats: true,
    authEndpoint: process.env.SOCKET_AUTH_HOST + '/broadcasting/auth',
    enabledTransports: ['ws', 'wss']
  }

  if (typeof options.socketId === 'function') {
    app.config.globalProperties.$echo = options
  }
  else {
    app.config.globalProperties.$echo = new Echo(options)
  }

  app.mixin({
    created () {
      let channel = this.$options['channel']

      if (typeof channel === 'function') {
        channel = channel.bind(this).call()
      }

      if (channel) {
        if (channel.startsWith('private:')) {
          this.channel = this.$echo.private(channel.replace('private:', ''))
        }
        else if (channel.startsWith('presence:')) {
          this.channel = this.$echo.join(channel.replace('presence:', ''))
        }
        else {
          this.channel = this.$echo.channel(channel)
        }

        const events = this.$options['echo']

        if (events) {
          Object.keys(events).forEach(function (key) {
            // Bind the VM as second parameter
            this.channel.listen(key, (payload) => {
              events[key].bind(this)(payload)
            })
          }, this)
        }
      }
    },
    beforeUnmount () {
      if (this.$options['channel']) {
        this.channel.unsubscribe()
      }
    }
  })
}
